import React from 'react';
import { useFormContext } from 'react-hook-form';

import { AdditionalInfoFormFields } from '@/booking/validators/additional-info-form.validator';
import { useTranslation } from '@/i18n';
import { TextArea } from '@/ui/form';

export const SpecialRequestsTextInput = ({
  hotelReferenceId,
}: {
  hotelReferenceId: string;
}) => {
  const { t } = useTranslation('additionalInformation');

  const {
    register,
    formState: { errors },
    trigger,
  } = useFormContext<Pick<AdditionalInfoFormFields, 'specialRequests'>>();

  return (
    <TextArea
      label=""
      placeholder={t('specialRequests.placeholder', {
        // TODO: a hack until we properly support hotel level translations
        hotelName:
          hotelReferenceId === 'orientexpress.laminerva-rome'
            ? 'Orient Express La Minerva'
            : hotelReferenceId === 'orientexpress.palazzodonagiovannelli-venice'
            ? 'Orient Express Palazzo Donà Giovannelli'
            : '',
      })}
      error={errors.specialRequests?.message}
      {...register('specialRequests', {
        onChange: () => trigger('specialRequests'),
      })}
    />
  );
};

export default SpecialRequestsTextInput;
